// extracted by mini-css-extract-plugin
export default {"header":"KrdcO","logo":"UWJqE"};